const SocketActionTypes = {
  USER_MESSAGES: "USER_MESSAGES",
  DIRECTOR_SCANNER: "DIRECTOR_SCANNER",
  DIRECTOR_CHANGED: "DIRECTOR_CHANGED",
  SET_EXCHANGE_RATE: "SET_EXCHANGE_RATE",
};

export default SocketActionTypes;
